import classNames from "clsx";

export type DropDownMenuArrowProps = {
  className?: string;
  "data-testid"?: string;
};

export const DropDownMenuArrow = ({
  className: additionalClasses,
  "data-testid": dataTestId,
}: DropDownMenuArrowProps) => (
  <i
    className={classNames("icon-lt-arrow-right-s-line", "ml-2", "text-text-base-primary", "text-md", additionalClasses)}
    data-testid={dataTestId ?? "dropdown-menu-arrow"}
  />
);
